import * as React from 'react';
import EntityMark from './entity-mark';
import getTranslatedText from './getTranslatedText';

export default function EntitiesFound(props: EntitiesFoundProps): JSX.Element {
    const { results, hoveredEntity, onHover } = props;
    const { annotations, knowledge_base: knowledgeBase } = results.results;

    const groupedAnnotations = annotations.reduce((acc, annotation) => {
        if (acc[annotation.entity_kb_id]) acc[annotation.entity_kb_id].count += 1;
        else acc[annotation.entity_kb_id] = { count: 1, annotation: { ...annotation } };

        return acc;
    }, {} as Record<string, { count: number; annotation: Annotation }>);

    return (
        <div className="nerd-demo__entities-found">
            {Object.values(groupedAnnotations).map(value => (
                <p key={value.annotation.text}>
                    <EntityMark
                        annotation={value.annotation}
                        knowledgeBase={knowledgeBase}
                        hoveredEntity={hoveredEntity}
                        onHover={onHover}
                        color={results.colorMap[value.annotation.entity_kb_id]}
                        popoverMetadata={[
                            { title: knowledgeBase === 'capiq' ? 'Capital IQ ID:' : 'Wikimedia ID:', value: value.annotation.entity_kb_id },
                            { title: getTranslatedText('entityType'), value: value.annotation.entity_type },
                            { title: getTranslatedText('instancesFound'), value: value.count.toString() }
                        ]}
                    >
                        {value.annotation.text}
                    </EntityMark>
                    <span>&nbsp;({value.count})</span>
                </p>
            ))}
        </div>
    );
}
